module.exports = __webpack_public_path__ + "img/box-score-blue.c18dde0f.svg";